import { call, put } from "redux-saga/effects";

import { api, notify } from "services";
import { IFechRequest } from "interfaces/fetch-duck";
import { requestErrorHandler } from "utils";
import { FetchFileSchedulingFobActions } from "store/ducks/ordersFob";

export function* fetchFileSchedulingFobActionsRequest(action: any) {
  try {
    const { id, onSuccess } = action as IFechRequest;
    const { data } = yield call(api.get, `/file-scheduling-fob/${id}`);

    yield put(FetchFileSchedulingFobActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(FetchFileSchedulingFobActions.failure(errorMessage));
  }
}
